import { useEffect } from "react";

const Logout = () => {
  useEffect(() => {
    const crmUser = localStorage.getItem('crmUser');
    if (crmUser) {
      localStorage.removeItem('crmUser');
    }
    const userData = localStorage.getItem('userData');
    if (userData) {
      localStorage.removeItem('userData');
    }
    window.location.href = '/';
  }, []);

  return (
    <div id="logout"></div>
  );
};

export default Logout;
